export default __webpack_public_path__ + "static/media/driver-license1.def32abc.jpg";